export default class SendToFriend {
    constructor() {
        const form = $('#sendToFriendForm');
        if (form.length) {
            this.init(form);
        }
    }
    init(form) {
        form.on('submit', e => {
            $('button[type=submit]', form)
                .addClass('disabled')
                .attr('disabled', 'disabled');
        })
    }
}